<template>
	<c-modal @close="close" :title="'Adres toevoegen'">

		<c-form ref="form" @valid="submit" class="margin-t-40">

			<c-zipcode-address v-if="this.edit"
				:label="'Postcode en hnr.'"
				:sublabel="'Bezoekadres'"
				:horizontal="true"
				:zipcode="address.zipcode"
				:number="address.number"
				:street="address.street"
				:city="address.city"
				:addition="address.addition !== null ? address.addition : ''"
				:locationName="address.name !== null ? address.name : ''"
				name="*"
				ref="zipcode"
			/>

			<c-zipcode-address v-else
				:label="'Postcode en hnr.'"
				:sublabel="'Bezoekadres'"
				:horizontal="true"
				name="*"
				ref="zipcode"
			/>

			<div class="row collapse align-right">
				<div class="columns shrink">
					<c-button class="c-btn--expanded margin-t-32 margin-b-16" type="submit">{{ title }}</c-button>
				</div>
			</div>

		</c-form>

	</c-modal>
</template>

<script>

import Form from '@mixins/Form';
import CModal from '@components/Modal';
import CZipcodeAddress from '@components/ZipcodeAddress';
import { ValidationError } from '@app/errors';

export default {
	mixins: [Form],
	components: {
		CModal,
		CZipcodeAddress
	},
	props: {
		edit: {
			required: false
		},
		client_id: {
			required: true
		},
		address: {
			required: false
		}
	},
	data() {
		return {
			text: '',
			title: 'Toevoegen'
		};
	},
	watch: {
	},
	methods: {
		submit() {

			 let clientData = {
                client_id: this.client_id,
			 };

			let data = Object.assign(clientData, this.$refs.zipcode.getData());

			if(this.edit){
				this.$xhr.put('/api/addresses/' + this.address.id, data).then( ( {result}) => {
					this.$store.dispatch('toast/success', {title: 'Adres wijzigen', text: 'Het Adres is gewijzigd'});
					this.close();
					this.$emit('added');
				}).catch( (e) => {
					if (e instanceof ValidationError) {
						this.$refs.form.setErrors(e.errors);
					}
					this.$store.dispatch('toast/alert', {title: 'Adres wijzigen', text: 'Er is helaas iets fout gegaan bij het wijzigen van het Adres'});
				});
			}
			else {
				this.$xhr.post('/api/addresses', data).then( ( {result}) => {
					this.$store.dispatch('toast/success', {title: 'Adres aanmaken', text: 'Het Adres is aangemaakt'});
					this.close();
					this.$emit('added');
				}).catch( (e) => {
					if (e instanceof ValidationError) {
						this.$refs.form.setErrors(e.errors);
					}
					this.$store.dispatch('toast/alert', {title: 'Adres aanmaken', text: 'Er is helaas iets fout gegaan bij het aanmaken van het Adres'});
				});
			}
		},
		close() {
			this.$emit('close');
		},
	},
	mounted(){
		if(this.edit){
			this.title = 'Wijzigen';
		}
	}
	
}
</script>
